import { Box } from '@mui/material'

import { EnergyCostTab } from '../../types'

interface TabToggleProps {
  selectedTab: EnergyCostTab
  onTabChange: (tab: EnergyCostTab) => void
}

const TabToggle = ({ selectedTab, onTabChange }: TabToggleProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        position: 'relative',
        borderRadius: '12px',
        marginBottom: '16px',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: '2px solid #F5F5F7',
          borderRadius: '12px',
          pointerEvents: 'none',
          zIndex: 0,
        },
      }}
    >
      <Box
        onClick={() => onTabChange(EnergyCostTab.Outlook)}
        sx={{
          flex: 1,
          padding: '12px 16px',
          textAlign: 'center',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '20px',
          letterSpacing: '0.1px',
          backgroundColor: selectedTab === EnergyCostTab.Outlook ? '#181D29' : 'transparent',
          color: selectedTab === EnergyCostTab.Outlook ? '#ffffff' : undefined,
          borderRadius: '12px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          position: 'relative',
          zIndex: 1,
        }}
      >
        Energiekostenausblick
      </Box>
      <Box
        onClick={() => onTabChange(EnergyCostTab.Funding)}
        sx={{
          flex: 1,
          padding: '12px 16px',
          textAlign: 'center',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '20px',
          letterSpacing: '0.1px',
          backgroundColor: selectedTab === EnergyCostTab.Funding ? '#181D29' : 'transparent',
          color: selectedTab === EnergyCostTab.Funding ? '#ffffff' : undefined,
          borderRadius: '12px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          position: 'relative',
          zIndex: 1,
        }}
      >
        Förderungen
      </Box>
    </Box>
  )
}

export default TabToggle
